module.exports = __webpack_public_path__ + "static/media/worker-hourly.a3a8f1cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/worker-hourly.svg
// module id = 286
// module chunks = 36